import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=44131213&"
import script from "./SurveyItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports